import React from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from '../hooks/useWindowSize';

/**
 * Props interface for the DrawWizardConfetti component
 */
export interface DrawWizardConfettiProps {
  width?: number;
  height?: number;
  colors?: string[];
  numberOfPieces?: number;
  recycle?: boolean;
}

/**
 * Plexus design system color palette for confetti
 */
const PLEXUS_CONFETTI_COLORS = [
  '#00DB65', // Plexus primary green
  '#00B052', // Plexus green variant
  '#0F9944', // Darker green
  '#1DB584', // Teal green
  '#00C78B', // Mint green
];

/**
 * DrawWizardConfetti - A simple confetti component with Plexus design system colors
 */
const DrawWizardConfetti: React.FC<DrawWizardConfettiProps> = ({
  width,
  height,
  colors = PLEXUS_CONFETTI_COLORS,
  numberOfPieces = 400,
  recycle = true,
}) => {
  const { width: windowWidth, height: windowHeight } = useWindowSize();

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      <Confetti
        width={width || windowWidth}
        height={height || windowHeight}
        numberOfPieces={numberOfPieces}
        recycle={recycle}
        colors={colors}
        friction={0.99}
        wind={0}
        gravity={0.1}
        initialVelocityX={4}
        initialVelocityY={10}
      />
    </div>
  );
};

export default DrawWizardConfetti;
